<script>
import { redirectToLogin } from "../../helpers/routerHelper";
import { mapActions } from "vuex";
import {regexPatterns} from "../../utils/utils";
import {countries} from "../../utils/countries";

export default {
  name: "registrationSection",
  data() {
    return {
      registrationFormRules: {
        firstName: [
          {
            required: true,
            message: "Please enter your first name",
            trigger: "none"
          }
        ],
        lastName: [
          {
            required: true,
            message: "Please enter your last name",
            trigger: "none"
          }
        ],
        email: [
          {
            required: true,
            message: "Please enter your email address",
            trigger: "none"
          },
          {
            pattern: regexPatterns.email,
            required: true,
            message: "Please enter valid email address",
            trigger: "none"
          }
        ],
        countryCode: [
          {
            required: true,
            message: "Please select country code",
            trigger: "change"
          }
        ],
        mobileNumber: [
          {
            required: true,
            message: "Please enter your mobile number",
            trigger: "none"
          },
          {
            min: 9,
            max: 15,
            message: "Please enter valid mobile number",
            trigger: "none"
          },
          {
            pattern: regexPatterns.mobileRegEx,
            message: "Please enter valid mobile number",
            trigger: "none"
          },
        ],
        password: [
          {
            required: true,
            message: "Please enter your password",
            trigger: "none"
          }
        ],
        confirmPassword: [
          { validator: this.validateConfirmPassword, trigger: "none" }
        ]
      },
      registrationForm: {
        firstName: "",
        lastName: "",
        email: "",
        countryCode: "+61",
        mobileNumber: "",
        password: "",
        confirmPassword: ""
      }
      // viewPassword:false,
      // viewConfirmPassword:false,
      // isSubscribedToEmailingList: false,
      // subscribedToEmailingListText: 'Subscribe to our email mailing list to hear about new arrivals, offers and exclusive deals',
      // isSubscribedToSmsList: false,
      // subscribedToSmsListText: 'Subscribe for SMS updates to hear about new arrivals, offers and exclusive deals',
    };
  },
  methods: {
    countries() {
      return countries
    },
    ...mapActions("register", ["registerAccount"]),
    redirectToLogin,
    createAccount() {
      var that = this;
      let pat = {
        firstName: this.registrationForm.firstName,
        lastName: this.registrationForm.lastName,
        email: this.registrationForm.email,
        countryCode: this.registrationForm.countryCode,
        mobileNumber: this.registrationForm.mobileNumber,
        password: this.registrationForm.password,
        confirmPassword: this.registrationForm.confirmPassword
      };
      console.log(pat);
      that.$refs.registrationForm.validate(valid => {
        if (valid) {
          that.$box.loadings(3);
          this.registerAccount({
            params: pat,
            callback: that.createAccountCallback
          });
        } else {
          that.$box.loadings(2);
          Utils.alert("", "Please fill the mandatory fields", "error");
          return false;
        }
      });
    },
    createAccountCallback(res) {
      console.log("callback register");
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        var previousPath = localStorage.getItem('previousPath');
        localStorage.clear();
        // localStorage.setItem('token',res.data.data.token )
        // localStorage.setItem('flagPass', res.data.data.flagPass)
        // localStorage.setItem('flagAgreement', res.data.data.flagAgreement)
        // localStorage.setItem('mode', 'off')
        if (previousPath) {
          localStorage.setItem('previousPath', previousPath);
        }
        that.$box.alert("", "Account created successfully", "success");
        that.$router.push("/newlogin");
      } else if (res.data.code == 70010) {
        that.warn2 = true;
      } else if (res.data.code == 40007) {
        that.warn = true;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/newlogin");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/newlogin");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    validateConfirmPassword(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please enter password confirmation"));
      } else if (value !== this.registrationForm.password) {
        callback(new Error("Does not match passwords"));
      } else {
        callback();
      }
    },
    validateMobileNumber(rule, value, callback) {
      if (!value.startsWith("0")) {
        callback("Mobile number should start with 0");
      } else {
        callback();
      }
    }
  }
};
</script>

<template>
  <el-row class="create-account-section">
    <el-col :span="24">
      <img
        class="create-account-background"
        loading="lazy"
        src="../../assets/AgentLoginBackground.jpg"
      />
      <div class="sign-up-outer-wrapper">
        <el-row class="sign-up-inner-wrapper" >
          <el-col :span="24" class="sign-up-title-wrapper">
            <span class="sign-up-title">Create an account</span>
          </el-col>
          <el-col :span="24" class="sign-up-form-wrapper">
            <div style="background-color: #ffffff; border-radius: 0 0 15px 15px; padding: 0 16px 30px 16px">
              <el-form
                ref="registrationForm"
                :hide-required-asterisk="true"
                :model="registrationForm"
                :rules="registrationFormRules"
              >
                <el-row style="width: 100%">
                  <el-col :span="24" style="padding: 16px 0">
                    <el-form-item prop="firstName" style="padding: 0">
                      <el-input
                        v-model="registrationForm.firstName"
                        placeholder="First Name"
                      >
                        <template slot="prepend"
                        ><i class="el-icon-edit-outline"
                        /></template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row style="width: 100%">
                  <el-col :span="24" style="padding-bottom: 16px">
                    <el-form-item prop="lastName" style="padding: 0">
                      <el-input
                        v-model="registrationForm.lastName"
                        placeholder="Last Name"
                      >
                        <template slot="prepend"
                        ><i class="el-icon-edit-outline"
                        /></template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row style="width: 100%">
                  <el-col :span="24" style="padding-bottom: 16px">
                    <el-form-item prop="email" style="padding: 0">
                      <el-input
                        v-model="registrationForm.email"
                        placeholder="Email Address"
                      >
                        <template slot="prepend"
                        ><i class="el-icon-message"
                        /></template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row style="width: 100%">
                  <el-col :span="24" style="padding-bottom: 16px">
                    <el-row :gutter="5">
                      <el-col :span="8">
                        <el-form-item prop="countryCode" style="padding: 0">
                          <el-select
                            v-model="registrationForm.countryCode"
                            placeholder="Country Code"
                            filterable
                          >
                            <el-option
                              v-for="country in countries()"
                              :key="country.code"
                              :label="`${country.code} ${country.dialCode}`"
                              :value="country.dialCode">
                              <span><b>{{ country.name }}</b> <span style="color: #9a9a9a">({{ country.code }})</span> {{ country.dialCode }}</span>
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="16">
                        <el-form-item prop="mobileNumber" style="padding: 0">
                          <el-input
                            v-model="registrationForm.mobileNumber"
                            placeholder="Mobile Number"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>

<!--                    <el-form-item prop="mobileNumber" style="padding: 0">-->
<!--                      <el-input placeholder="Mobile Number" v-model="registrationForm.mobileNumber">-->
<!--                        <el-select v-model="registrationForm.countryCode" slot="prepend" style="max-width: 110px; min-width: 100px" placeholder="Country Code" filterable>-->
<!--                          <el-option-->
<!--                            v-for="country in countries()"-->
<!--                            :key="country.code"-->
<!--                            :label="`${country.code} ${country.dialCode}`"-->
<!--                            :value="country.dialCode">-->
<!--                            <span><b>{{ country.name }}</b> <span style="color: #9a9a9a">({{ country.code }})</span> {{ country.dialCode }}</span>-->
<!--                          </el-option>-->
<!--                        </el-select>-->
<!--                      </el-input>-->
<!--                      <el-input-->
<!--                        v-model="registrationForm.mobileNumber"-->
<!--                        placeholder="Mobile Number"-->
<!--                      >-->
<!--                        <template slot="prepend"><i class="el-icon-phone"/></template>-->
<!--                      </el-input>-->
<!--                    </el-form-item>-->
                  </el-col>
                </el-row>
                <el-row style="width: 100%">
                  <el-col :span="24" style="padding-bottom: 16px">
                    <el-form-item prop="password" style="padding: 0">
                      <el-input
                        id="passwordfield"
                        v-model="registrationForm.password"
                        placeholder="Password"
                        show-password
                        @keyup.enter.native="createAccount"
                      >
                        <template slot="prepend"><i class="el-icon-lock"/></template>
                        <!--              <template v-if="!viewPassword" slot="append"><i @click="viewPassword = !viewPassword"-->
                        <!--                                                              class="el-icon-view"/></template>-->
                        <!--              <template v-if="viewPassword" slot="append"><i><img src="../../assets/el-icon-hide.svg"-->
                        <!--                                                                  @click="viewPassword = !viewPassword"-->
                        <!--                                                                  class="icon-hide"/></i></template>-->
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row style="width: 100%">
                  <el-col :span="24" style="padding-bottom: 16px">
                    <el-form-item prop="confirmPassword" style="padding: 0">
                      <el-input
                        id="confirmpasswordfield"
                        v-model="registrationForm.confirmPassword"
                        placeholder="Confirm Password"
                        show-password
                        @keyup.enter.native="createAccount"
                      >
                        <template slot="prepend"><i class="el-icon-lock"/></template>
                        <!--              <template v-if="!viewConfirmPassword" slot="append"><i @click="viewConfirmPassword = !viewConfirmPassword"-->
                        <!--                                                                     class="el-icon-view"/></template>-->
                        <!--              <template v-if="viewConfirmPassword" slot="append"><i><img src="../../assets/el-icon-hide.svg"-->
                        <!--                                                                         @click="viewConfirmPassword = !viewConfirmPassword"-->
                        <!--                                                                         class="icon-hide"/></i></template>-->
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!--        <el-row style="width: 100%">-->
                <!--          <el-col :span="24" style="padding-bottom: 16px">-->
                <!--            <el-checkbox :label="subscribedToEmailingListText" :key="subscribedToEmailingListText">-->
                <!--              <template :v-slot="'prepend'">-->
                <!--                &lt;!&ndash;              <el-row>&ndash;&gt;-->
                <!--                &lt;!&ndash;                <el-col :span="24">&ndash;&gt;-->
                <!--                <span class="checkbox-text">Subscribe to our email mailing list to hear <br>about new arrivals, offers and exclusive deals</span>-->
                <!--                &lt;!&ndash;                </el-col>&ndash;&gt;-->
                <!--                &lt;!&ndash;              </el-row>&ndash;&gt;-->
                <!--              </template>-->
                <!--            </el-checkbox>-->
                <!--          </el-col>-->
                <!--        </el-row>-->
                <!--        <el-row style="width: 100%">-->
                <!--          <el-col :span="24" style="padding-bottom: 16px">-->
                <!--            <el-checkbox :label="subscribedToSmsListText" :key="subscribedToSmsListText">-->
                <!--              <template :v-slot="'prepend'">-->
                <!--                &lt;!&ndash;              <el-row>&ndash;&gt;-->
                <!--                &lt;!&ndash;                <el-col :span="24">&ndash;&gt;-->
                <!--                <span class="checkbox-text">Subscribe for SMS updates to hear <br>about new arrivals, offers and exclusive deals.</span>-->
                <!--                &lt;!&ndash;                </el-col>&ndash;&gt;-->
                <!--                &lt;!&ndash;              </el-row>&ndash;&gt;-->
                <!--              </template>-->
                <!--            </el-checkbox>-->
                <!--          </el-col>-->
                <!--        </el-row>-->
                <el-row style="width: 100%">
                  <el-col
                    :span="24"
                    style="padding-bottom: 16px; display: flex; flex-direction: column"
                  >
                    <el-button class="btn-primary" @click="createAccount"
                    >Create an account</el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <el-row class="login-wrapper" >
              <el-col :span="24"  class="login-inner-wrapper" >
                         <span  class="login-txt">Already have an account?
                      <el-button
                        class="login-btn"
                        type="text"
                        @click="redirectToLogin"
                      >Sign in here</el-button
                      ></span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

      </div>
    </el-col>
  </el-row>
</template>


<style scoped>
.create-account-section {
  background-color: #0d0d0d;
  padding: 50px 16px;
}

.create-account-background {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.5;
}

.sign-up-outer-wrapper {
  display: flex;
  justify-content: center;

  position: relative;
  padding: 20px 16px 30px 16px;
  background-color: transparent;
}
.sign-up-title-wrapper {
  background-color: #003333;
  padding: 20px;
  border-radius: 15px 15px 0 0;
}
.icon-hide{
  width: 20px;
  height: 20px;
}
.sign-up-title {
  color: #ffffff;
  font-family: DINosaur-a;
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 117.647%;
  align-self: stretch;
}
.btn-primary {
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 14px 60px;
  font: 600 20px Metropolis, sans-serif;
}
.login-inner-wrapper{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.login-txt{
  color: #ffffff;
  font: 400 15px DINosaur-a, sans-serif;
}
.login-btn{
  border-bottom: 1px solid #ffffff;
  padding-bottom: 2px;
  margin-left: 10px;
  border-radius: 0;
  color: #ffffff;
  font: 500 16px DINosaur-a, sans-serif;
}
@media only screen and (min-width: 768px) {

}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {

}
@media only screen and (min-width: 1400px) {

}

</style>



// WEBPACK FOOTER //
// src/components/register/registrationSection.vue